import { render, staticRenderFns } from "./StyleManagerGroupEditor.vue?vue&type=template&id=4cb03474"
import script from "./StyleManagerGroupEditor.vue?vue&type=script&lang=js"
export * from "./StyleManagerGroupEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports